import { BaseService, Service } from "/@/cool";
@Service("shopAllocation")
class shopAllocation extends BaseService {
	constructor() {
		super();

		let prefix = "";
		if (this.namespace) {
			prefix = this.namespace.replace(/\//g, ":") + ":";
		}

		this.permission["add"] = prefix + "add";
		this.permission["page"] = prefix + "page";
		this.permission["shopList"] = prefix + "shopList";
		
	}
	shopList(params: any) {
		return this.request({
			url: "/shopList",
			method: "POST",
			data: { ...params }
		});
	}
}
export default shopAllocation;
